import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import Error from "../components/error/Error";
import { setCompanyLoading } from "../redux/company/company-slice";

import { setMultiCompanyEnabled } from "../redux/multiple-companies/multiple-companies-slice";

interface CompanyProviderProps {
  children: React.ReactNode;
}

const CompanyProvider: React.FC<CompanyProviderProps> = ({ children }) => {
  const dispatch = useDispatch();

  const companyLoading = useSelector(
    (state: RootState) => state.company.loading
  );
  const companyError = useSelector((state: RootState) => state.company.error);

  const isLoggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const userIsAdmin = useSelector((state: RootState) => state.user.isSuperuser);

  const loadData = async () => {
    if (companyLoading || !isLoggedIn) {
      return;
    }
    //dispatch(setCompanyLoading(true));

    dispatch(
      setMultiCompanyEnabled(userIsAdmin !== undefined ? userIsAdmin : false)
    );

    /*let error = true;
    let requestCount = 0;
    const urlToUse = "/companies/default/";
    while (requestCount < MAX_REQUEST_COUNT) {
      const requestStatus = await getItem<Company>(urlToUse);

      if (requestStatus.status !== SUCCESS) {
        requestCount += 1;
        continue;
      }

      error = false;
      dispatch(setCompany(requestStatus.data!));
      break;
    }

    if (error === true) {
      dispatch(setCompanyErrorLoading(true));
      return;
    }*/
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (companyError) {
    return <Error />;
  }

  return <>{children}</>;
};

export default CompanyProvider;
